import { FILE_TYPES } from "../data";

const convertBase64ToDataUrl = (base64: string, type = FILE_TYPES.PNG) => {
    return `data:${type};base64,${base64}`;
};

export default convertBase64ToDataUrl;